const BrokenPage = () => (
  <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4 bg-slate-50">
    <div className="bg-white rounded-3xl shadow-card px-10 py-14 max-w-sm w-full">
      <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-5 text-2xl">⚠️</div>
      <h2 className="font-display text-2xl font-semibold text-slate-900 mb-2">Something went wrong</h2>
      <p className="font-body text-slate-500 text-sm mb-6 leading-relaxed">
        We're sorry — something seems to have broken. Try refreshing the page or come back shortly.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="w-full h-11 rounded-xl bg-primary-900 text-white font-body font-semibold text-sm hover:bg-primary-800 transition-colors mb-3"
      >
        Refresh page
      </button>
      <a href="/" className="block w-full h-11 rounded-xl border-2 border-slate-200 text-slate-700 font-body font-semibold text-sm hover:border-primary-400 hover:text-primary-900 transition-all flex items-center justify-center">
        Go to homepage
      </a>
    </div>
  </div>
);
export default BrokenPage;
